import { IIndicatorReportService } from './indicators.types'
import { ReportParameter } from '@/entities'
import { http } from '@/shared/https'

export class IndicatorReportService implements IIndicatorReportService {

    /** Get the filters */
    getFilters(): any {
        return http.get('api/MEGrowthReport/GetFilter')
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    /** get the progress report */
    getProgressReport(indPath: Array<string>, params: Array<ReportParameter>): any {

        // var queryObj: any = {};

        const indParam: ReportParameter = new ReportParameter({
            "Name" : "Indicator Path",
            "Field": "Path.tree",
            "Type": "ComboBox",
            "DataType": "string",
            "Values": indPath,
            "Operator": "=="
        });


        return http.post('api/MEGrowthReport', [ ...params, indParam ] ).then((resp: any) => {
            return resp;
        });
    }
}